import styled from "@emotion/styled";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import { fontRoboto } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import ArrowIcon from "./arrow.svg";

export const StyledAccordion = styled(Accordion)`
  ${".MuiAccordionSummary-root"} {
    align-items: flex-start;

    min-block-size: unset;
    padding-block: 8px 0;
    padding-inline: 16px;

    ${theme.breakpoints.up("tablet")} {
      padding-inline: 26px;
    }
  }

  ${".MuiAccordionSummary-content"} {
    margin-block: 0;
  }

  ${".MuiAccordionSummary-expandIconWrapper"} {
    margin-block-start: 4px;
  }

  ::before {
    background-color: transparent;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)``;

export const StyledArrowIcon = styled(ArrowIcon)`
  transform: rotate(180deg);
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  margin-inline: 18px 8px;
  padding-block: 16px;
  padding-inline: 14px 8px;
  border-inline-start: 1px #dfdfdf dashed;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 30px 20px;
    padding-block: 16px;
    padding-inline: 14px 8px;
  }
`;

export const Title = styled.li`
  display: flex;
  flex-flow: row wrap;
  gap: 2px 6px;

  font-variant-numeric: lining-nums proportional-nums;

  time {
    color: #888888;
    font-weight: 400;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: normal;
    letter-spacing: -0.28px;
  }

  span {
    color: #888888;
    font-weight: 400;
    font-size: 14px;
    font-family: ${fontRoboto};
  }

  div {
    color: #404040;
    font-weight: 700;
    font-size: 14px;
    font-family: ${fontRoboto};

    ${theme.breakpoints.only("mobile")} {
      inline-size: 100%;
      margin-inline-start: 2px;
      padding-inline-start: 14px;
      border-inline-start: 1px #dfdfdf dashed;
    }
  }

  ::before {
    content: "●";

    margin-inline: 0 2px;

    font-size: 14px;
  }
`;
